import { CannedMessage } from "@_types/CannedMessage";
import { api } from ".";

export async function fetchCannedMessages() {
  const response = await api.get<CannedMessage[]>("/cannedMessage");

  return response.data;
}